import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "row q-col-gutter-lg" }
const _hoisted_5 = { class: "col-8" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col q-mb-md" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", { class: "q-mb-sm" }, "Agreement members", -1)
const _hoisted_9 = { class: "col-auto" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "col-4 column" }
const _hoisted_13 = { class: "q-gutter-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn_toggle = _resolveComponent("q-btn-toggle")!
  const _component_agreement_single_member = _resolveComponent("agreement-single-member")!
  const _component_agreement_new_member = _resolveComponent("agreement-new-member")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h6", null, "Agreement: " + _toDisplayString(_ctx.agreement.name) + " - members management", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", null, "Currently assigned: " + _toDisplayString(_ctx.currentlyAssigned.length) + " of " + _toDisplayString(_ctx.agreement.memberLimit), 1),
            _createElementVNode("div", null, "Expired or removed: " + _toDisplayString(_ctx.expiredMembers), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_q_btn_toggle, {
              modelValue: _ctx.showActiveMembers,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showActiveMembers) = $event)),
              "toggle-color": "primary",
              options: [
                                { label: 'Active', value: true },
                                { label: 'Expired', value: false, disabled: _ctx.agreement.draft },
                                { label: 'All', value: 'all' }
                            ]
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAgreementMembers, (member, index) => {
              return (_openBlock(), _createBlock(_component_agreement_single_member, {
                key: index,
                member: member,
                agreementId: _ctx.agreement.agreementId,
                draft: _ctx.agreement.draft,
                expired: _ctx.agreement.status === 'expired'
              }, null, 8, ["member", "agreementId", "draft", "expired"]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_agreement_new_member, {
          agreementId: _ctx.agreement.agreementId
        }, null, 8, ["agreementId"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_q_btn, {
        label: "Go to list",
        color: "primary",
        onClick: _ctx.onGoToList,
        outline: "",
        unelevated: "",
        "no-caps": ""
      }, null, 8, ["onClick"]),
      _createVNode(_component_q_btn, {
        label: "Go to info",
        color: "primary",
        onClick: _ctx.onGoToInfo,
        outline: "",
        unelevated: "",
        "no-caps": ""
      }, null, 8, ["onClick"])
    ])
  ]))
}